module.exports = __webpack_public_path__ + "static/media/SOAL_A1.23b93906.svg";